/* eslint-disable */

import { Subscription } from "@/store/builder/types";
import Vue from "vue";
import Component from "vue-class-component";

interface Chat {
  id: number;
  name: string;
  image: File | Blob | string | null;
  blurred: boolean;
  highlight: string | null;
  subscriptions: Subscription[];
}

@Component
class WithBuilderFakeChats extends Vue {
  get builderFakeChats(): Chat[] {
    const now = Number(Date.now().toString());

    return [
      {
        id: -now * 2,
        name: "Новинки",
        image: "/img/fake-chat-avatar-1.png",
        blurred: false,
        highlight: null,
        subscriptions: [],
      },
      {
        id: -now * 3,
        name: "Фотоотчеты",
        image: "/img/fake-chat-avatar-2.png",
        blurred: false,
        highlight: null,
        subscriptions: [],
      },
      {
        id: -now * 4,
        name: "Новые видео",
        image: "/img/fake-chat-avatar-3.png",
        blurred: false,
        highlight: null,
        subscriptions: [],
      },
      {
        id: -now * 5,
        name: "Общение",
        image: "/img/fake-chat-avatar-4.png",
        blurred: false,
        highlight: null,
        subscriptions: [],
      },
    ];
  }
}

export default WithBuilderFakeChats;
